"use client";
import React, { useState } from "react";
import { toast } from "sonner";
import axios from "axios";

const api = axios.create({
  baseURL: 'https://localhost:7022',
  headers: {
    accept: "*/*",
    // Authorization: `Bearer ${token}`,
  },
});

function getUserData(): any {
  if (typeof window === "undefined") return null;
  const userData = localStorage.getItem("userData");
  return userData ? JSON.parse(userData) : null;
}

interface ApplyJobModalProps {
  jobId: string;
  jobTitle: string;
  open: boolean;
  onClose: () => void;
}

export default function ApplyJobModal({
  jobId,
  jobTitle,
  open,
  onClose,
}: ApplyJobModalProps) {
  const [applyForm, setApplyForm] = useState({
    ApplicantName: "",
    ApplicantEmail: "",
    Resume: "",
    CoverLetter: "",
    VideoPitch: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleApplySubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const user = getUserData();
      const payload = {
        studentId: user?._id ?? "",
        resume: applyForm.Resume,
        coverLetter: applyForm.CoverLetter,
        videoPitch: applyForm.VideoPitch,
        status: 1,
        jobId: jobId,
        jobResponse: {
          responseMessage: "",
          offerLetter: "",
          expiryDate: new Date().toISOString(),
          offerStatus: 1,
        },
      };
      console.log(payload);
      await api.post("/JobBoard/job-application", payload);
      toast.success("Application submitted!");
      setApplyForm({
        ApplicantName: "",
        ApplicantEmail: "",
        Resume: "",
        CoverLetter: "",
        VideoPitch: "",
      });
      onClose();
    } catch (error) {
      toast.error("Failed to submit application");
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-xl shadow-lg max-w-lg w-full p-8 relative">
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          onClick={onClose}
        >
          &times;
        </button>
        <h2 className="text-2xl font-bold mb-4">Apply for {jobTitle}</h2>
        <form onSubmit={handleApplySubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Name</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={applyForm.ApplicantName}
              onChange={(e) =>
                setApplyForm({ ...applyForm, ApplicantName: e.target.value })
              }
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              className="w-full border rounded px-3 py-2"
              value={applyForm.ApplicantEmail}
              onChange={(e) =>
                setApplyForm({ ...applyForm, ApplicantEmail: e.target.value })
              }
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Resume (URL or text)
            </label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={applyForm.Resume}
              onChange={(e) =>
                setApplyForm({ ...applyForm, Resume: e.target.value })
              }
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Cover Letter
            </label>
            <textarea
              className="w-full border rounded px-3 py-2"
              value={applyForm.CoverLetter}
              onChange={(e) =>
                setApplyForm({ ...applyForm, CoverLetter: e.target.value })
              }
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Video Pitch (URL)
            </label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2"
              value={applyForm.VideoPitch}
              onChange={(e) =>
                setApplyForm({ ...applyForm, VideoPitch: e.target.value })
              }
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full px-6 py-3 rounded-lg font-medium text-white bg-blue-600 hover:bg-blue-700"
          >
            {submitting ? "Submitting..." : "Submit Application"}
          </button>
        </form>
      </div>
    </div>
  );
}
